import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "../components/Logo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="bg-[#0d0718] text-[#ede8f5] min-h-screen flex flex-col">
      <div className="px-6 py-6 border-b border-[#2d1b4e]">
        <div className="max-w-6xl mx-auto"><Logo /></div>
      </div>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-md w-full text-center p-8 rounded-2xl bg-[#120a21] border border-[#2d1b4e]">
          <XCircle className="w-12 h-12 text-[#c084fc] mx-auto mb-4" />
          <h1 className="display-font text-2xl uppercase text-white mb-2">Pagamento Annullato</h1>
          <p className="text-sm text-[#94a3b8] mb-6">
            Nessun addebito è stato effettuato. Puoi riprendere l'acquisto quando vuoi:
            il tuo percorso ti aspetta.
          </p>
          <Link to="/" data-testid="payment-cancel-home"
            className="inline-block px-8 py-3.5 rounded-xl bg-gradient-to-r from-[#6a0dad] to-[#a020f0] text-white font-bold text-xs uppercase tracking-wider">
            Torna ai Pacchetti
          </Link>
        </div>
      </main>
    </div>
  );
}
